export default __webpack_public_path__ + "static/097-629484f8dc1009fc5aaacbda300d4326.jpg";